"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapMultiProperties = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _FieldMapper = _interopRequireWildcard3(require("./FieldMapper"));

var _Validations = require("../../Validations");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoadableCheckbox = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../CheckboxGroup"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});

var getValidations = function getValidations(field) {
  var validations = [];

  if (field.properties.isRequired) {
    validations.push(_Validations.requiredArrayValidation);
  }

  return validations;
};

var mapMultiMultiProperties = function mapMultiMultiProperties(field, model) {
  return _objectSpread(_objectSpread({}, model), {}, {
    name: model.id,
    component: LoadableCheckbox,
    options: (0, _FieldMapper.buildOptionArray)(field.properties.allowedValues).map(function (option) {
      return _objectSpread({
        id: "checkbox-option-".concat(option.value),
        name: "checkbox-option-".concat(option.value),
        disabled: field.isDisabled
      }, option);
    }),
    validations: getValidations(field),
    onChange: checkboxOnChange,
    value: model.value || field.properties.defaultValue || []
  });
};

var checkboxOnChange = function checkboxOnChange(params) {
  return {
    value: params[1]
  };
};

var mapMultiProperties = function mapMultiProperties(_ref) {
  var field = _ref.field,
      htmlId = _ref.htmlId,
      value = _ref.value,
      onValidation = _ref.onValidation;
  var model = (0, _FieldMapper.default)(field, htmlId, value, undefined, onValidation);

  switch (field.properties.editor) {
    case "Multi":
      return mapMultiMultiProperties(field, model);

    default:
      return null;
  }
};

exports.mapMultiProperties = mapMultiProperties;